
export const initialState = {
  taxesData: [],
  totalTax: 0,
  error: null,
};
